import api from "./api";

export const invitationService = {
  sendInvite: async (inviteData) => {
    try {
      console.log("Sending Invite:", inviteData);
      const response = await api.post(`/mapi/invite/invitation`, inviteData);
      return response.data;
    } catch (error) {
      console.error(
        "Error Sending Invite:",
        error.response?.data || error.message
      );
      throw error;
    }
  },

  verifyLink: async (inviteData) => {
    try {
      console.log("Verifying Link:", inviteData);
      const response = await api.post(`/mapi/entity/verifyLink`, inviteData);
      return response.data;
    } catch (error) {
      console.error(
        "Error Authenticating:",
        error.response?.data || error.message
      );
      throw error;
    }
  },

  cancelInvite: async (inviteData) => {
    try {
      console.log("Sending cancel invite:", inviteData);
      const response = await api.post(
        `/mapi/invite/cancelInvitation`,
        inviteData
      );
      return response.data;
    } catch (error) {
      console.error(
        "Error Sending  cancel Invite:",
        error.response?.data || error.message
      );
      throw error;
    }
  },

  bulkInvite: async ({ communityId, invitationList }) => {
    try {
      console.log("Sending Bulk Invite:", { communityId, invitationList });
      const response = await api.post(`/mapi/invite/bulkInvitation`, {
        CommunityId: communityId,
        InvitationData: invitationList,
      });
      return response.data;
    } catch (error) {
      console.error(
        "Error Sending Bulk Invite:",
        error.response?.data || error.message
      );
      throw error;
    }
  },

  reassignInvite: async (inviteData) => {
    try {
      console.log("Reassigning Invite:", inviteData);
      const response = await api.post(`/mapi/invite/reassign`, inviteData);
      return response.data;
    } catch (error) {
      console.error(
        "Error Reassigning Invite:",
        error.response?.data || error.message
      );
      throw error;
    }
  },

  reassignSignup: async (signupData) => {
    try {
      console.log("Submitting reassign Signup:", signupData);
      const response = await api.post(
        `/mapi/invite/reassignSignup`,
        signupData
      );
      return response.data;
    } catch (error) {
      console.error(
        "Error in Reassign Signup:",
        error.response?.data || error.message
      );
      throw error;
    }
  },

  reassignAddProfile: async (profileData) => {
    try {
      console.log("Adding Reassign Profile:", profileData);
      const response = await api.post(
        `/mapi/invite/reassignAddProfile`,
        profileData
      );
      return response.data;
    } catch (error) {
      console.error(
        "Error Adding Reassign Profile:",
        error.response?.data || error.message
      );
      throw error;
    }
  },

  invitationSignup: async (signupData) => {
    try {
      console.log("Submitting Invitation Signup:", signupData);
      const response = await api.post(
        `/mapi/invite/invitationSignup`,
        signupData
      );
      return response.data;
    } catch (error) {
      console.error(
        "Error in Invitation Signup:",
        error.response?.data || error.message
      );
      throw error;
    }
  },

  invitationAddProfile: async (profileData) => {
    try {
      console.log("Adding Invitation Profile:", profileData);
      const response = await api.post(
        `/mapi/invite/invitationAddProfile`,
        profileData
      );
      return response.data;
    } catch (error) {
      console.error(
        "Error Adding Invitation Profile:",
        error.response?.data || error.message
      );
      throw error;
    }
  },
};
